var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoErro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 41.67C29.9437 41.67 29.4 41.835 28.9375 42.144C28.4749 42.4531 28.1145 42.8923 27.9016 43.4062C27.6887 43.9202 27.633 44.4857 27.7415 45.0312C27.8501 45.5768 28.1179 46.0779 28.5113 46.4713C28.9046 46.8646 29.4057 47.1325 29.9513 47.241C30.4969 47.3495 31.0624 47.2938 31.5763 47.081C32.0902 46.8681 32.5295 46.5076 32.8385 46.0451C33.1476 45.5826 33.3125 45.0388 33.3125 44.4825C33.3125 43.7366 33.0162 43.0213 32.4887 42.4938C31.9613 41.9664 31.2459 41.67 30.5 41.67Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.625 21.045H32.375V37.92H28.625V21.045Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.875 54.795H6.125C5.80278 54.7957 5.48583 54.7133 5.20472 54.5559C4.92361 54.3984 4.68782 54.1711 4.52011 53.896C4.35239 53.6209 4.25841 53.3072 4.24722 52.9851C4.23604 52.6631 4.30803 52.3437 4.45625 52.0575L28.8312 5.18255C28.9886 4.87542 29.2276 4.61767 29.5221 4.43769C29.8165 4.25771 30.1549 4.16248 30.5 4.16248C30.8451 4.16248 31.1835 4.25771 31.4779 4.43769C31.7723 4.61767 32.0114 4.87542 32.1687 5.18255L56.5438 52.0575C56.692 52.3437 56.764 52.6631 56.7528 52.9851C56.7416 53.3072 56.6476 53.6209 56.4799 53.896C56.3122 54.1711 56.0764 54.3984 55.7953 54.5559C55.5142 54.7133 55.1972 54.7957 54.875 54.795ZM9.21875 51.045H51.7813L30.5 10.1138L9.21875 51.045Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 33.3374,
    y1: 43.3771,
    x2: 25.2651,
    y2: 49.5135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843EF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 32.3916,
    y1: 26.1663,
    x2: 24.1359,
    y2: 27.5609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843EF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 56.9862,
    y1: 19.5284,
    x2: -16.3399,
    y2: 77.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843EF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoErro);
export default __webpack_public_path__ + "static/media/ico_erro.a31e5e509de58e005107526b1085706a.svg";
export { ForwardRef as ReactComponent };